export default __webpack_public_path__ + "static/media/first-depositers.488fe0d2.webp";